import { html, sync, repeat } from '@genesislcap/web-core';
import type { SimulatorRoute } from './simulator';
import {customEvent} from '@genesislcap/foundation-events';

export const SimulatorTemplate = html<SimulatorRoute>`
  <div class="simulator-header">
    <h1>Simulator</h1>
  </div>
  
  <div class="simulator-main-container">
    <div class="bulk-quote-section">
      <h2>Send Bulk QuoteRequest messages</h2>
      <div class="input-group">
        <label>Number of Messages:</label>
        <rapid-number-field 
          placeholder="Enter number of messages" 
          min="1" 
          step="1" 
          value="${sync((x) => x.numberOfMessages)}"
        ></rapid-number-field>
      </div>
      <div class="input-group">
        <label>Bond Price Type:</label>
        <rapid-select 
          value="${sync((x) => x.selectedPriceType)}"
          buttonAppearance="outline"
        >
          <rapid-option value="PERCENTAGE">PERCENTAGE</rapid-option>
          <rapid-option value="SPREAD">SPREAD</rapid-option>
          <rapid-option value="YIELD">YIELD</rapid-option>
          <rapid-option value="NONE">NONE</rapid-option>
        </rapid-select>
      </div>
      <div class="input-group">
        <label>Due In Mins:</label>
        <rapid-number-field 
          placeholder="Enter due time in minutes" 
          min="0" 
          step="1" 
          value="${sync((x) => x.dueInMins)}"
        ></rapid-number-field>
      </div>
      <div class="input-group">
        <label>Firm Until Mins:</label>
        <rapid-number-field 
          placeholder="Enter firm time in minutes" 
          min="0" 
          step="1" 
          value="${sync((x) => x.firmInMins)}"
        ></rapid-number-field>
      </div>
      <div class="input-group">
        <label>Customer Type:</label>
        <rapid-select
          value="${sync((x) => x.selectedCustomerType)}"
          buttonAppearance="outline"
        >
          <rapid-option value="1">INSTITUTIONAL</rapid-option>
          <rapid-option value="2">RETAIL</rapid-option>
        </rapid-select>
      </div>
      <div class="input-group">
        <label>Target Counterparties:</label>
        <rapid-multiselect 
          placeholder="Select target counterparties" 
          :options="${(x) => x.targetCounterpartyDropdownItems}"
          :selectedOptions="${(x) => x.selectedTargetCounterparties}"
          @selectionChange=${(x, ctx) => x.onTargetCounterpartySelectionChange(customEvent(ctx))}
          buttonAppearance="outline"
        ></rapid-multiselect>
      </div>
      <div class="input-group">
        <label>Block Counterparties:</label>
        <rapid-multiselect 
          placeholder="Select block counterparties" 
          :options="${(x) => x.blockCounterpartyDropdownItems}"
          :selectedOptions="${(x) => x.selectedBlockCounterparties}"
          @selectionChange=${(x, ctx) => x.onBlockCounterpartySelectionChange(customEvent(ctx))}
          buttonAppearance="outline"
        ></rapid-multiselect>
      </div>
      <div class="button-group">
        <rapid-button appearance="primary" @click=${(x) => x.callEventSendQuoteRequests()}>
          Send QuoteRequest Messages
        </rapid-button>
      </div>
    </div>

    <div class="quote-status-section">
      <h2>Send QuoteStatusReport Message(s)</h2>
      <div class="input-group">
        <label>Reference#:</label>
        <rapid-text-field 
          placeholder="Enter reference#" 
          value="${sync((x) => x.reference)}"
        ></rapid-text-field>
      </div>
      <div class="input-group">
        <label>Counterparty Id:</label>
        <rapid-select 
          value="${sync((x) => x.counterpartyId)}"
          buttonAppearance="outline"
        >
          ${repeat(
            (x) => x.quoteStatusCounterpartyOptions,
            html<any>`
              <rapid-option value="${(x) => x.COUNTERPARTY_ID}">${(x) => x.COUNTERPARTY_ID}</rapid-option>
            `
          )}
        </rapid-select>
      </div>
      <div class="input-group">
        <label>Quote Status:</label>
        <rapid-select 
          value="${sync((x) => x.selectedQuoteStatus)}"
          buttonAppearance="outline"
        >
          <rapid-option value="REJECTED">REJECTED</rapid-option>
          <rapid-option value="PASS">PASS</rapid-option>
          <rapid-option value="DONE_AWAY">DONE_AWAY</rapid-option>
          <rapid-option value="COVER">COVER</rapid-option>
          <rapid-option value="FEEDBACK">FEEDBACK</rapid-option>
        </rapid-select>
      </div>
      <div class="input-group">
        <label>Text:</label>
        <rapid-text-field 
          placeholder="Enter text (optional)" 
          value="${sync((x) => x.quoteStatusText)}"
        ></rapid-text-field>
      </div>
      <div class="button-group">
        <rapid-button appearance="primary" @click=${(x) => x.callEventSendQuoteStatusReport()}>
          Send QuoteStatusReport
        </rapid-button>
      </div>
    </div>

    <div class="execution-report-section">
      <h2>Send ExecutionReport</h2>
      <div class="input-group">
        <label>Reference#:</label>
        <rapid-text-field 
          placeholder="Enter reference#" 
          value="${sync((x) => x.executionReference)}"
        ></rapid-text-field>
      </div>
      <div class="input-group">
        <label>Counterparty Id:</label>
        <rapid-select 
          value="${sync((x) => x.executionCounterpartyId)}"
          buttonAppearance="outline"
        >
          ${repeat(
          (x) => x.executionCounterpartyOptions,
          html<any>`
            <rapid-option
              value=${(x) => x.COUNTERPARTY_ID}
              :selected=${sync((x, c) => x.COUNTERPARTY_ID == c.parent.executionCounterpartyId)}
            >
              ${(x) => x.COUNTERPARTY_ID}
            </rapid-option>
          `,
        )}
        </rapid-select>
      </div>
      <div class="input-group">
        <label>Text:</label>
        <rapid-text-field 
          placeholder="Enter text (optional)" 
          value="${sync((x) => x.executionText)}"
        ></rapid-text-field>
      </div>
      <div class="button-group">
        <rapid-button appearance="primary" @click=${(x) => x.callEventSendExecutionReport()}>
          Send ExecutionReport
        </rapid-button>
      </div>
    </div>
  </div>
`;
